// extracted by mini-css-extract-plugin
export default {"blockTitle":"BAnalysisView-module_blockTitle_c840510b","fullscreen":"BAnalysisView-module_fullscreen_e3963d9c"};